export default __webpack_public_path__ + "static/FairplexWide-Book-fd5ce6617d6176bd43644d30fda2581f.woff2";